import { getCollaborationNotesFile, saveMessageWithFiles } from "@/api/collaboration-notes";
import { getOrderAttachments } from "@/apiv2/customDeliveryDocket";
import { createAction, createSetterActions } from "@/redux/helpers/action";
import { handleError } from "@/redux/utils/error";
import { STATUS } from "@/utils/constants";

import * as selectors from "./attachments-section.selectors";
import { getFileType, MODULE } from "./constants";

const ALLOWED_ATTACHMENT_FILE_TYPES = [
  "application/pdf",
  "application/dwg",
  "application/dxf",
  "image/vnd.dwg",
  "image/vnd.dxf",
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/heic",
];

// Simple setter actions
export const [
  setIsFetchingAttachmentsStatus,
  setIsAttachmentsLoading,
  setAttachments,
  setSelectedAttachments,
] = createSetterActions(MODULE, [
  "isFetchingAttachmentsStatus",
  "isAttachmentsLoading",
  "attachments",
  "selectedAttachments",
]);

export const reset = createAction(`${MODULE}/RESET`);

// Thunks

const filterAllowedAttachments = (data) =>
  data.filter((attachment) => ALLOWED_ATTACHMENT_FILE_TYPES.includes(attachment.type));

export const fetchOrderAttachments =
  ({ customerUid, orderUid }) =>
  async (dispatch) => {
    dispatch(setIsFetchingAttachmentsStatus(STATUS.PENDING));

    const response = await getOrderAttachments({ customerUid, orderUid })();
    dispatch(setAttachments(filterAllowedAttachments(response.data)));

    dispatch(setIsFetchingAttachmentsStatus(STATUS.FULFILLED));
  };

export const addSelectedAttachment =
  ({ id, type, fullUrl }) =>
  (dispatch, getState) => {
    const current = selectors.selectedAttachments(getState());
    dispatch(setSelectedAttachments([...current, { id, type, fullUrl }]));
  };

export const removeSelectedAttachment =
  ({ id }) =>
  (dispatch, getState) => {
    const current = selectors.selectedAttachments(getState());
    dispatch(setSelectedAttachments(current.filter((item) => item.id !== id)));
  };

export const addAttachments =
  ({ customerUid, orderUid, file }) =>
  async (dispatch) => {
    dispatch(setIsAttachmentsLoading(true));
    const data = new FormData();
    const token = JSON.parse(localStorage.getItem("auth"));

    data.set(
      "json",
      JSON.stringify({
        order_id: orderUid,
        message: "",
      })
    );

    data.append("files", file);

    try {
      const res = await saveMessageWithFiles(token, data);

      const response = res.data;
      const attachment = response?.order_chat_message_file[0];
      const attachmentId = attachment?.id ?? "";
      const attachmentType = attachment?.type ?? "";
      const attachmentFullUrl = attachment?.full_url ?? "";

      dispatch(
        addSelectedAttachment({
          id: attachmentId,
          type: getFileType(attachmentType),
          fullUrl: attachmentFullUrl,
        })
      );

      const attachmentResponse = await getOrderAttachments({
        customerUid,
        orderUid,
      })();
      dispatch(setAttachments(filterAllowedAttachments(attachmentResponse.data)));
    } catch (error) {
      handleError(error, dispatch);
    } finally {
      dispatch(setIsAttachmentsLoading(false));
    }
  };

export const viewFile =
  ({ customerUid, orderUid, fileId }) =>
  async () => {
    const token = JSON.parse(localStorage.getItem("auth"));

    const response = await getCollaborationNotesFile(customerUid, orderUid, fileId, token);
    const fileUrl = window.URL.createObjectURL(
      new File([response.data], fileId, { type: response.data.type })
    );
    window.open(fileUrl);
  };
